module.exports = __webpack_public_path__ + "img/kkb_plugbox_harting.60c40398.jpg";